import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  FileText, 
  FileJson, 
  FileSpreadsheet, 
  X, 
  Download,
  Share
} from 'lucide-react';

/**
 * Export options dropdown component
 * Rendered at the highest z-index to ensure visibility
 */
const ExportOptions = React.memo(({ 
  isVisible, 
  onClose, 
  selectedConversation, 
  onExportConversation, 
  onExportAllConversations,
  position = { top: 0, right: 0 }
}) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div 
        initial={{ opacity: 0, y: -10, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -10, scale: 0.95 }}
        className="fixed min-w-64 bg-slate-800/95 backdrop-blur-sm rounded-xl shadow-xl py-2 border border-slate-700/80 overflow-hidden"
        style={{
          zIndex: 9999, // Ultra-high z-index to be above everything
          top: `${position.top}px`,
          right: `${position.right}px`
        }}
      >
        <div className="px-4 py-2 border-b border-slate-700/50 bg-gradient-to-r from-emerald-800/30 to-emerald-700/20">
          <h3 className="font-medium text-emerald-300">Export Options</h3>
        </div>
        
        {selectedConversation ? (
          <>
            <div className="px-4 py-2.5 text-sm text-slate-300 bg-slate-800/60 flex items-center gap-2">
              <Download size={14} className="text-emerald-500" />
              <span>Export current conversation</span>
            </div>
            <button 
              onClick={() => onExportConversation('text')}
              className="w-full px-4 py-2.5 text-left text-sm hover:bg-emerald-600/20 flex items-center text-slate-200 transition-colors"
            >
              <FileText className="w-4 h-4 mr-2.5 text-emerald-400" />
              Plain Text (.txt)
            </button>
            <button 
              onClick={() => onExportConversation('json')}
              className="w-full px-4 py-2.5 text-left text-sm hover:bg-emerald-600/20 flex items-center text-slate-200 transition-colors"
            >
              <FileJson className="w-4 h-4 mr-2.5 text-emerald-400" />
              JSON Format (.json)
            </button>
            <button 
              onClick={() => onExportConversation('csv')}
              className="w-full px-4 py-2.5 text-left text-sm hover:bg-emerald-600/20 flex items-center text-slate-200 transition-colors"
            >
              <FileSpreadsheet className="w-4 h-4 mr-2.5 text-emerald-400" />
              CSV Format (.csv)
            </button>
          </>
        ) : (
          <>
            <div className="px-4 py-2.5 text-sm text-slate-300 bg-slate-800/60 flex items-center gap-2">
              <Share size={14} className="text-emerald-500" />
              <span>Export all conversations</span>
            </div>
            <button 
              onClick={() => onExportAllConversations('json')}
              className="w-full px-4 py-2.5 text-left text-sm hover:bg-emerald-600/20 flex items-center text-slate-200 transition-colors"
            >
              <FileJson className="w-4 h-4 mr-2.5 text-emerald-400" />
              All Chats (JSON)
            </button>
            <button 
              onClick={() => onExportAllConversations('csv')}
              className="w-full px-4 py-2.5 text-left text-sm hover:bg-emerald-600/20 flex items-center text-slate-200 transition-colors"
            >
              <FileSpreadsheet className="w-4 h-4 mr-2.5 text-emerald-400" />
              All Chats (CSV)
            </button>
          </>
        )}

        <div className="border-t border-slate-700/50 mt-2 pt-2 bg-slate-800/50">
          <button 
            onClick={onClose}
            className="w-full px-4 py-2.5 text-left text-sm text-red-400 hover:bg-red-900/20 flex items-center transition-colors"
          >
            <X className="w-4 h-4 mr-2.5" />
            Cancel
          </button>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
));

export default ExportOptions;